export default "__VITE_ASSET__vcm$xAoe__"